<div class="dialog-content">
  <div class="header">
    <h2>{{'Table management'}}</h2>
    <mat-icon [matDialogClose] matTooltip="{{ 'Cancel' | translate }}"> close </mat-icon>
  </div>
  <mat-form-field appearance="fill" class="table-label" [hintLabel]="'balabla'">
    <mat-label>{{'Table management' | translate}}</mat-label>
    <input matInput placeholder="Table content" [(ngModel)]="value" required>
    <!-- @if (data.type === 'multi') {
      <textarea matInput [(ngModel)]="value"
                cdkTextareaAutosize
                placeholder="Table content"
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5" 
                required></textarea>
    } @else {
      <input matInput placeholder="Table content" [(ngModel)]="value" required>
    } -->
  </mat-form-field>
  @if (data.type === 'multi') {
    <!-- <ul>
      <li>separate tables by one space</li>
      <li>(A2) - mark table as life stamp</li>
    </ul> -->
  }
  @else {
    <form [formGroup]="formGroup">
      <mat-checkbox formControlName="lifeStamp">Life stamp</mat-checkbox>
      <mat-checkbox formControlName="yesOrNot">Yes or Not</mat-checkbox>
      <mat-checkbox formControlName="or">Or</mat-checkbox>
      @if (formGroup.get('or').value) {
        <mat-form-field appearance="fill">
          <mat-label>{{'Alternative table' | translate}}</mat-label>
          <input matInput placeholder="Alternative table" formControlName="orTable" required>
        </mat-form-field>
      }
      <mat-checkbox formControlName="cancelled">Cancelled</mat-checkbox>
    </form>
  }
  <mat-dialog-actions align="end">
    <button mat-button [disabled]="!value || !formGroup.valid" (click)="saveTable()">{{'Save table'}}</button>
  </mat-dialog-actions>
</div>
